import AllRoutes from '.';

const Routes = () => {
    return <AllRoutes />;
};

export default Routes;
